<template>
  <el-footer class="govgr-layout-wrapper" style="height: initial;" role="contentinfo">
    <div class="govgr-full-width-container">
      <div class="gov-text-center-alignment" v-if="showAppInfo">
        <b>Release | Frontend: </b>
        <el-tooltip
          placement="top"
          :open-delay="800"
          effect="light"
          popper-class="release-details-tooltip"
        >
          <div slot="content" class="release-tooltip-content">
            <div class="tooltip-section">
              <div><strong>Release ID:</strong> {{ config.currentRelease.id }}</div>
              <div><strong>Version:</strong> {{ config.currentRelease.version }}</div>
              <div class="multi-line-text"><strong>Title:</strong> {{ config.currentRelease.title }}</div>
            </div>
            <div class="tooltip-section">
              <div><strong>Build Details:</strong></div>
              <div class="indent">
                <div>Number: {{ config.currentRelease.build.number }}</div>
                <div>Author: {{ config.currentRelease.build.author }}</div>
                <div>Start Date: {{ config.currentRelease.build.startDate }}</div>
                <div>Build Date: {{ config.currentRelease.build.date || 'N/A' }}</div>
                <div>Issues: {{ formatIssues(config.currentRelease.build.issues) }}</div>
              </div>
            </div>
            <div class="tooltip-section">
              <div><strong>Commit:</strong></div>
              <div class="indent">
                <div class="multi-line-text">Message: {{ config.currentRelease.build.commit.message }}</div>
                <div>Date: {{ config.currentRelease.build.commit.date || 'N/A' }}</div>
                <div>SHA: {{ formatSha(config.currentRelease.build.commit.sha) }}</div>
              </div>
            </div>
          </div>
          <span>{{ config.FRONTEND_RELEASE }}, </span>
        </el-tooltip>
        <b>Backend: </b>
        <el-tooltip
          v-if="backendReleaseData"
          placement="top"
          :open-delay="800"
          effect="light"
          popper-class="release-details-tooltip"
        >
          <div slot="content" class="release-tooltip-content">
            <div class="tooltip-section">
              <div><strong>Version:</strong> {{ backendReleaseData.version }}</div>
              <div><strong>Date:</strong> {{ backendReleaseData.date }}</div>
              <div><strong>Issue:</strong> {{ backendReleaseData.issue }}</div>
              <div class="multi-line-text"><strong>Description:</strong> {{ backendReleaseData.description }}</div>
            </div>
            <div class="tooltip-section" v-if="backendReleaseData.changes">
              <div><strong>Changes:</strong></div>
              <div class="indent">
                <div v-for="(changeList, changeType) in backendReleaseData.changes" :key="changeType">
                  <div><strong>{{ formatChangeType(changeType) }}:</strong></div>
                  <ul class="changes-list">
                    <li v-for="(change, index) in changeList" :key="index">{{ change }}</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <span>{{ backendVersion }}</span>
        </el-tooltip>
        <span v-else>{{ backendVersion }}</span>
        <b> URL:</b> {{ config.BASE_URL }} <b>User type:</b> {{ config.USER_TYPE }}
      </div>
      <div class="govgr-footer__meta">
      <div class="govgr-footer__meta-item govgr-footer__meta-item--grow">
        <div class="govgr-footer__content gov-text-valign-center">
          <p class="govgr-footer__licence-description">
            <span @click="toggleAppInfo">© Copyright 2020</span>
             - Υλοποίηση από το <a href="https://www.minedu.gov.gr/" target="_blank" rel="noreferrer noopener" class="govgr-link"> Υπουργείο Παιδείας, Θρησκευμάτων και Αθλητισμού</a>
          </p>
        </div>
        <div class="govgr-footer__meta-item">
         <a href="https://e-doatap.doatap.gr">
          <img class="gov-footer-secondary-logo" src="../assets/Logo-eDoatap_Color.png"/>
          </a>
      </div>
      <!-- <div class="govgr-footer__content govgr-footer__licence-description">
         {{ $t('about') }}
      <el-button type="text" @click="toggleComment">
        {{ $t('report') }}
      </el-button>
      <div class="body" v-show="showComment">
        <el-input
          type="textarea"
          :autosize="{ minRows: 2, maxRows: 8 }"
          :placeholder="$t('placeholder')"
          v-model="textarea"
        >
          class="message">
        </el-input>
        <el-button
          class="butt"
          type="primary"
          style="float: right"
          @click="sendComment"
          >{{ $t('submit') }}
        </el-button>
      </div>
        </div> -->
      </div>
    </div>
    </div>
    <div class="govgr-full-width-container">
      <div class="govgr-footer__content">
        <div class="gov-text-center-alignment">
          {{ developmentTeam }}
        </div>
      </div>
    </div>
  </el-footer>
</template>

<script>
import config from '../config.js'

export default {
  name: 'Foot',
  data () {
    return {
      config: config,
      showAppInfo: config.DEBUG,
      developmentTeam: `Ομάδα Ανάπτυξης Λογισμικού του τμήματος Β' Διαλειτουργικότητας, 
          Ψηφιακής Σύγκλισης και Διοικητικής Υποστήριξης της 
          Δ/νσης Ηλεκτρονικής Διακυβέρνησης και Απλούστευσης Διαδικασιών του Υ.ΠΑΙ.Θ.Α.`,
      backendVersion: 'Loading...',
      backendReleaseData: null
    }
  },
  mounted () {
    config.getBackendRelease().then(version => {
      this.backendVersion = version
      this.backendReleaseData = config.getBackendReleaseData()
    })
  },
  methods: {
    toggleAppInfo (event) {
      if (event.ctrlKey || event.metaKey) {
        this.showAppInfo = !this.showAppInfo
      }
    },
    formatIssues (issues) {
      if (!issues || issues.length === 0) return 'None'
      return issues.map(i => `#${i}`).join(', ')
    },
    formatSha (sha) {
      if (!sha) return 'N/A'
      return sha.substring(0, 8)
    },
    formatChangeType (type) {
      return type
        .split('_')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ')
    }
  }
}
</script>

<style scoped>
.release-tooltip-content {
  font-size: 13px;
  line-height: 1.6;
  max-width: 500px;
}
.tooltip-section {
  margin-bottom: 12px;
}
.tooltip-section:last-child {
  margin-bottom: 0;
}
.tooltip-section .indent {
  margin-left: 16px;
  margin-top: 4px;
}
.multi-line-text {
  white-space: pre-line;
}
.changes-list {
  margin: 4px 0 8px 0;
  padding-left: 20px;
}
.changes-list li {
  margin-bottom: 2px;
  display: list-item;
  list-style-type: disc;
  list-style-position: inside;
}
</style>

<style>
.release-details-tooltip {
  max-width: 600px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Foot.vue